import FuturesClientCategorisation from '@/features/futures/components/client-categorisation';
import FuturesClientCategorisationLayout from '@/features/futures/layouts/client-categorisation';

const FuturesClientCategorisationPage = () => {
  return (
    <FuturesClientCategorisationLayout progress={0.33}>
      <FuturesClientCategorisation />
    </FuturesClientCategorisationLayout>
  );
};
FuturesClientCategorisationPage.displayName = 'FuturesClientCategorisationPage';

export default FuturesClientCategorisationPage;
